const ID_TOKEN_KEY = 'token' as string;
const ID_PERMISSION_KEY = 'permissions' as string;

/**
 * @description get token form localStorage
 */
export const getToken = (): string | null => window.localStorage.getItem(ID_TOKEN_KEY);

/**
 * @description save token into localStorage
 * @param token: string
 */
export const saveToken = (token: string): void => {
  window.localStorage.setItem(ID_TOKEN_KEY, token);
};

export const savePermissions = (permissions: string[]): void => {  
  window.localStorage.setItem(ID_PERMISSION_KEY,JSON.stringify(permissions));
};

/**
 * @description remove token form localStorage
 */
export const destroyToken = (): void => {
  window.localStorage.removeItem(ID_TOKEN_KEY);
};

export const destroyPermissions = (): void => {
  window.localStorage.removeItem(ID_PERMISSION_KEY);
};

export default { getToken, saveToken, savePermissions, destroyToken, destroyPermissions };